<template>
  <div id='header_wrapper' role='banner'>
    <div id ='header' class='container-fluid'>
      <div style='margin:auto; max-width:1400px;'>
        <div class='row no-gutters' >
          <div class='col-auto'>
            <img v-if='this.$store.state.site=="cibc"'  class='cibcLogo' src="../assets/images/cibc-logo-lg.png" style='z-index: 1; position:relative;' alt="CIBC Logo"/>
            <img v-else-if='this.$i18n.locale==="en"' class='cibcLogo' src="../assets/images/cibcinsurance-logo-lg-en.png" style='z-index: 1; position:relative;' alt="CIBC Logo"/>
            <img v-else class='cibcLogo' src="../assets/images/cibcinsurance-logo-lg-fr.png" style='z-index: 1; position:relative;' alt="CIBC Logo"/>
            
          </div>
          <div class='col'>
            <div class='headerText d-none d-lg-block'>
              <span v-if='this.$store.state.site==="cibc"' style='padding-left:25px;'>{{$t('text.header_label')}}</span>
              <span v-else style='padding-left:25px;'>{{$t('text.header_labelnm')}}</span>
            </div>
          </div>
          <div class='col-auto'>
            <div class='headerText d-none d-lg-block'>
              <span style='padding-right:25px;'>{{$t('text.distributedby')}}</span>
            </div>
          </div>
          <div class='col col-sm-auto text-center'>
            <div style='display:inline-block;' class='text-left'>
              <img class='allianzLogo' src="../assets/images/allianz_logo.png" style='z-index: 1; position:relative;' alt="Allianz Logo"/>
            </div>
          </div>
          <div v-if="this.$store.state.product!==''&&this.$route.meta.page!== 13" class='col-auto d-none d-md-block' style='padding-top:35px;'>
            <button id='btnCoverageDetails' class='btnHelp form-control' @click='openCoverageDetails($event)'>{{$t("text.coveragedetails")}}</button>
          </div>
          <div class='col-auto d-none d-md-block' style='padding-top:10px;'>
            <div class='row no-gutters'>
              <div class="customSelectDiv d-print-none" style='margin-top:30px;'>
                <span class="selectDefault">EN</span>
                <select v-model='language' id="languagePicker" class="selectBox" :aria-label='$t("text.changeLanguage")'>
                  <option value="EN" style='padding:20px;'>English</option>
                  <option value="FR">Francais</option>
                </select>
              </div>
            </div>
          </div>
          <div class='col-auto d-block d-md-none' style='padding-top:25px;'>
            <button id='switchMenuControl' @click='switchMenu()' aria-controls='menuBar' aria-expanded='false' class='topNavLink switchMenuControl'>
              <div class='text-center nav-dropdown'>
                <img src='../assets/images/megamenu.png' alt="Menu"/>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if='this.$route.meta.page>1' class='progressBar container-fluid'>
      <div class='row'>
        <div :class='progressbar' style='background-color: #333333;'></div>
        <div v-if='this.$route.meta.page<13' class='col' style='background-color: #CCCCCC;'></div>
      </div>
    </div>

    <div id='mbOverlay' @click='switchMenu()'>
      <div id='menuBar' role='navigation'>
        <div class='row menuBarRow'>
          <div class='col my-auto'>
            <a @click='switchLanguage("")' href='javascript:void(0);' class='topNavLink'>{{$t('text.link_language')}}</a>
          </div>
        </div>
        <div v-if='this.$store.state.product!==""' class='row menuBarRow' style='border-top:1px solid #cccccc;'>
          <div class='col my-auto'>
            <a id='btnCoverageDetails2' @click='openCoverageDetails($event)' href='javascript:void(0);' class='topNavLink'>Coverage Details</a>
          </div>
        </div>
        <div class='row menuBarRow' style='border-top:1px solid #cccccc;'>
          <div class='col my-auto'>
            <a @click='openNeedHelpModal()' href='javascript:void(0);' class='topNavLink'>{{$t('text.btn_needhelp')}}</a>
          </div>
        </div>
      </div>
    </div>

    <div v-show='languageModalVisible' id='languageModal'>
      <div class='col-12' style='border-bottom: 1px solid #cccccc; font-size: 20px; padding: 20px;'>
        <div class='row'>
          <div class='col'><a @click='switchLanguage("en")' href='javascript:void(0);' class='topNavLink'>English</a></div>
          <div class='col-auto'>
            <img v-if='this.$i18n.locale==="en"' src="../assets/images/checkmarkblack.png" style='margin-top:5px;'/>
          </div>
        </div>
      </div>
      <div class='col-12' style='border-bottom: 1px solid #cccccc; font-size: 20px; padding: 20px;'>
        <div class='row'>
          <div class='col'><a @click='switchLanguage("fr")' href='javascript:void(0);' class='topNavLink'>Francais</a></div>
          <div class='col-auto'>
            <img v-if='this.$i18n.locale==="fr"' src="../assets/images/checkmarkblack.png" style='margin-top:5px;'/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { initKeywords } from "../utils/keywords.js";
import { initCustomSelect } from "../utils/customSelect.js";
import { getSurveyQuestions } from "../utils/getSurveyQuestions.js";
import getLocale from "../utils/getLocale";
import { setCookieConsent, getCookieConsent } from "../utils/cookieConsent.js";
import { validateForm } from "../utils/validation.js";
import { validationRules } from "../utils/validation_rules.js";

import bus from "../utils/bus.js";

export default {
  data() {
    return {
      languageModalVisible: false,
    }
  },
  computed: {
    url1() {
        let pathInsert="";
        const pathArray=window.location.pathname.split("/");
        if(pathArray[1]==="cibc"||pathArray[2]==="cibc"||pathArray[1]==="cibcinsurance"||pathArray[2]==="cibcinsurance"){ pathInsert="/cibc"}
        return (
            window.location.origin +
            pathInsert + 
            "/assets/documents/" +
            this.$i18n.t("text.link_privacy")
        );
    },
    progressbar: {
      get() {
        return "col-"+ (this.$route.meta.page - 1) 
      }
    },
    language: {
      get() {
        return this.$i18n.locale.toUpperCase();
      },
      set(newValue){
        this.switchLanguage(newValue.toLowerCase());
      }
    }
  },
  methods: {
    switchLanguage(targetLanguage) {
      // If no target Language set, alternate language.
      if(targetLanguage===""){
        if(this.$i18n.locale==="fr") {targetLanguage="en"}
        else {targetLanguage="fr"}
      }

      let pathInsert="";
      const pathArray=window.location.pathname.split("/");
      if(pathArray[1]==="cibc"||pathArray[2]==="cibc"){ pathInsert="/cibc"; }
      else if(pathArray[1]==="cibcinsurance"||pathArray[2]==="cibcinsurance"){ pathInsert="/cibcinsurance"}
      
      if (this.$i18n.locale === "en"&&targetLanguage==="fr") {
        this.$i18n.locale = "fr";
        document.cookie = ".AspNetCore.Culture=l-fr; path=/";;
        window.history.pushState(
          this.$route.path,
          "Travel Insurance - CIBC",
          "/fr-CA" + pathInsert + "/#" + this.$route.path
        );
        document.cookie = ".AspNetCore.Culture=l-fr; path=/";
        document.documentElement.setAttribute("lang","fr");
      } else if(this.$i18n.locale === "fr"&&targetLanguage==="en") {
        this.$i18n.locale = "en";
        document.cookie = ".AspNetCore.Culture=l-en; path=/";
        window.history.pushState(
          this.$route.path,
          "Travel Insurance - CIBC",
          "/en-CA" + pathInsert + "/#" + this.$route.path
        );
        document.cookie = ".AspNetCore.Culture=l-en; path=/";
        document.documentElement.setAttribute("lang","en");
      }
      this.languageModalVisible = false;
    
      this.$nextTick(()=>{
        if(this.$route.path==="/Questionnaire1"||this.$route.path==="/Questionnaire2"||this.$route.path==="/Questionnaire3"){
          getSurveyQuestions();
        }        
        else if(this.$route.meta.page===8) {
          bus.$emit("sendOfferRequest");
        } else if(this.$route.meta.page>8) {
          bus.$emit("sendOfferRequest", true);
        }
        
        // Clear error messagse
        const errorList = document.getElementsByClassName("invalid-feedback");
        if(errorList.length>0){       
          bus.$emit("changeStep", this.$route.path, "", true);
        }

        initKeywords();
      });
    },
    OpenInNewWindow(url, width, height) {
      const popupWidth = width == null ? 500 : width;
      const popupHeight = height == null ? 600 : height;
      const newWindow = window.open(
        url,
        "popup",
        "scrollbars=1,resizable=1,width=" +
          popupWidth +
          ",height=" +
          popupHeight
      );
    },
    openCoverageDetails(event) {
      for(const category in this.$store.state.products){
        for(const product of this.$store.state.products[category].Products){
          if(event.target.getAttribute("data-product")===product.Product.ProductCode){
            bus.$emit("openCoverageDetails", product, event.target);
          }
        }
      }  
    },
    switchMenu(){
      if(document.getElementById("mbOverlay").style.display==="block") {
        document.getElementById('switchMenuControl').setAttribute('aria-expanded', false);
        document.getElementsByTagName("body")[0].classList.remove("modal-open");
        document.getElementById("mbOverlay").style.display = "none";
      } else {
        document.getElementById('switchMenuControl').setAttribute('aria-expanded', true);
        document.getElementsByTagName("body")[0].classList.add("modal-open");
        document.getElementById("mbOverlay").style.display = "block";
      }
    },
    setCookieBanner(){
        let code = '';
        const isLocal = ['localhost', 'test'].some(urlTest => window.location.origin.toLowerCase().includes(urlTest));

        if (this.$store.state.site === 'cibc') {
            code = isLocal ? "ae508f97-b45c-4b3b-9ecc-73a312642452-test" : "a8ab0595-a5ce-4a93-aa36-3738e5123981"
        } else {
            code = isLocal ? "16086ef9-81e6-4aa7-a283-561b25de9fe3-test" : "16086ef9-81e6-4aa7-a283-561b25de9fe3"
        }

        let startComment = document.createComment(' OneTrust Cookies Consent Notice start for cibc.allianz-assistance.ca ');
        let endComment = document.createComment(' OneTrust Cookies Consent Notice end for cibc.allianz-assistance.ca ');

        document.head.appendChild(startComment);

        let oneTrustScript = document.createElement('script');
        oneTrustScript.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
        oneTrustScript.setAttribute('type', 'text/javascript');
        oneTrustScript.setAttribute('charset', 'UTF-8');
        oneTrustScript.setAttribute('data-document-language', 'true');
        oneTrustScript.setAttribute('data-domain-script', code);
        document.head.appendChild(oneTrustScript);

        // Run 
        let oneTrustFct = document.createElement('script');
        oneTrustFct.setAttribute('type', 'text/javascript');
        oneTrustFct.innerText = 'function OptanonWrapper() {}';  
        document.head.appendChild(oneTrustFct)

        document.head.appendChild(endComment);

        // Script Adobe Launch
        const adobeScriptDtm = document.createElement('script');
        adobeScriptDtm.setAttribute('src', 'https://assets.adobedtm.com/dd4adce84cad/87444ae84c23/launch-8d81a855376b.min.js');
        adobeScriptDtm.setAttribute('async', '');

        document.head.appendChild(adobeScriptDtm);

    },
    openNeedHelpModal(){
      document.getElementById("needHelpDiv").children[0].click();
    }
  },
  mounted(){
    this.setCookieBanner();    
    document.getElementById("languagePicker").addEventListener("focus", (event)=> {
      event.target.parentNode.classList.add("isFocused");
    });
    document.getElementById("languagePicker").addEventListener("blur", (event)=> {
      event.target.parentNode.classList.remove("isFocused");
    });

    initCustomSelect(document.getElementById("languagePicker"));
  }
};
</script>

<style>
#menuBar{
  background-color: #ffffff;
  text-align:center;
}
#mbOverlay{
  display: none;
  /* Height & width depends on how you want to reveal the overlay (see JS below) */   
  width: 100%;
  top:100px;
  bottom:0pt;
  position: fixed; /* Stay in place */
  z-index: 10; /* Sit on top */
  left: 0;
  right:0;
  background-color: rgba(0,0,0, 0.5); /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.2s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
}
.menuBarRow {
  height:60px;
  padding-top:3px;
  padding-bottom:3px;
  align-items: center;
}

.nmlogo {
    margin-top: 10px;
    border:1px solid white;
}
a.topNavLink:active,
a.topNavLink:link,
a.topNavLink:visited {
  color: #000000;
}
a.topNavLink:hover {
  color: #000000;
  text-decoration: underline;
}

.headerText {
  margin-top: -5px;
  text-align:center;
  font-family: Glober-Regular;
  font-size: 16pt;
  font-weight: bold;
  color: rgb(110, 110, 110);
  line-height: 120px;
}
.progressBar div{
  height: 5px;
}

.localizationText {
  font-size: 16pt;
  padding-right: 0px;
  line-height: 50px;
}

#languageModal {
  position: absolute; 
  top: 70;
  right:40;
  z-index: 1;
  width:180px; 
  background-color: #FFFFFF;
  box-shadow: 0 1px 8px 0 rgba(0,0,0,0.15);
  border-radius: 9px;
}
#btnCoverageDetails {
  margin-right:25px;
}
.isFocused {
  box-shadow: 0 0 0 0.2rem #000000 inset;
}
.cookiebanner {
  padding:20px;
}
.switchMenuControl {
  border: 0px;
  padding: 0px;
  cursor: pointer;
}

</style>
